import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { useLeftBar } from "../../../context/LeftBar";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";

const StyledNavItem = styled("li")(({ theme }) => ({
  listStyle: "none",
  "& .navItemNameContainer": {
    display: "flex",
    alignItems: "center",
    // padding: theme.spacing(1, 2),
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5, 1),
      gap: theme.spacing(1),
    },
  },
  "& .iconWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
      minWidth: 35,
    },
  },
  "& .navItemName": {
    transition: theme.transitions.create(["opacity", "width"], {
      duration: theme.transitions.duration.shorter,
    }),
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
    },
  },
  "& .navItemName.is-hidden": {
    opacity: 0,
    width: 0,
    overflow: "hidden",
  },
  "& .subPagesList": {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(2),
    },
  },
  "& .subNavLink": {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.813rem",
      padding: theme.spacing(0.75, 1),
    },
  },
}));

function NavItem({ icon, muiIcon, name, path, subpages, onClick, customClass, isActive, hideIcon }) {
  const { leftBarOpened } = useLeftBar();
  const [showSubPageItems, setShowSubPageItems] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (
      subpages &&
      subpages.some((s) => s.url === location.pathname) &&
      !showSubPageItems
    ) {
      setShowSubPageItems(true);
    }
  }, [location.pathname, showSubPageItems, subpages]);

  return (
    <StyledNavItem className={`navItem ${customClass || ""}`}>
      <NavLink
        to={path}
        activeClassName="active"
        isActive={(match, location) => {
          if (isActive === false) return false;
          return subpages
            ? subpages.some((subpage) => subpage.url === location.pathname)
            : path === location.pathname;
        }}

        onClick={(e) => {
          if (subpages) {
            e.preventDefault();
            setShowSubPageItems(!showSubPageItems);
          }
          onClick?.();
        }}
      >
        <div className="navItemNameContainer">
          {!hideIcon && (!leftBarOpened ? (
            <Tooltip title={name} placement="right">
              <div className="iconWrapper">
                {icon ? <i className={`${icon}`} /> : muiIcon}
              </div>
            </Tooltip>
          ) : icon ? (
            <i className={`${icon}`} />
          ) : (
            muiIcon
          ))}
          <span
            className={`${leftBarOpened ? "navItemName" : "navItemName is-hidden"} ${customClass || ''}`}
          >
            {name}
          </span>
        </div>
      </NavLink>
      {subpages && leftBarOpened && (
        <>
          <i
            className={
              showSubPageItems ? "fal fa-angle-up" : "fal fa-angle-down"
            }
          />
          <ul
            className={
              showSubPageItems
                ? "subPagesList showSubPageItems"
                : "subPagesList"
            }
          >
            {showSubPageItems &&
              subpages.map((subpage) => (
                <li className="subNavItems" key={subpage.id}>
                  <NavLink
                    className="subNavLink"
                    to={subpage.url}
                    activeClassName="subItemActive"
                  >
                    {subpage.name}
                  </NavLink>
                </li>
              ))}
          </ul>
        </>
      )}
    </StyledNavItem>
  );
}

NavItem.defaultProps = {
  icon: "",
  name: "",
  path: "",
  subpages: undefined,
};

NavItem.propTypes = {
  icon: PropTypes.string,
  name: PropTypes.string,
  path: PropTypes.string,
  subpages: PropTypes.array,
  onClick: PropTypes.func,
  customClass: PropTypes.string,
};

export default NavItem;
